import styled from 'styled-components';
import { desktopMediaQuery } from '../../styleHelpers';
import { PRIMARY_COLOR_DIMMED } from '../../constants';
import NewCTAButton from './NewCTAButton';
import { SectionSeparator } from './SectionSeparator';

interface ContentSectionProps {
  src: string;
  title: string;
  description: string;
  flipCard?: boolean;
}

const ContentSection = ({
  src,
  title,
  description,
  flipCard = false,
}: ContentSectionProps) => {
  console.log('src', src);
  return (
    <OuterContainer>
      <SectionSeparator />
      <ResponsiveContainer $flipCard={flipCard}>
        <ImageInContentSection src={src} />
        <CardContainer>
          <CardTitle>{title}</CardTitle>
          <CardText>{description}</CardText>
        </CardContainer>
      </ResponsiveContainer>

      <NewCTAButton />
    </OuterContainer>
  );
};

export default ContentSection;

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 95vw;
`;

const ResponsiveContainer = styled.div<{ $flipCard: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;

  ${desktopMediaQuery} {
    flex-direction: row;
    justify-content: center;
    gap: 5vw;
    max-width: 80vw;
    margin-top: 32px;
    margin-bottom: 32px;
    flex-direction: ${({ $flipCard }) => ($flipCard ? 'row-reverse' : 'row')};
  }
`;

const ImageInContentSection = styled.img`
  width: 85vw;
  height: 85vw;
  max-width: 450px;
  max-height: 450px;
  border-radius: 36px;
  margin-bottom: 16px;
  object-fit: cover;
  object-position: top;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 85vw;
  max-width: 650px;
  padding: 24px;

  background-color: none;
  border-radius: 8px;

  box-shadow: 2px 2px 4px ${PRIMARY_COLOR_DIMMED};
`;

const CardTitle = styled.h2`
  text-align: start;
  width: 100%;
  font-size: 24px;
  margin-top: 0;
`;

const CardText = styled.div`
  li {
    list-style-type: none;
    margin-bottom: 8px;
  }
`;
